import React, { useRef, useEffect, useCallback, useState} from 'react';
import {PAD} from 'packs/pack-types.js';
import {useScrollTo} from "components/selector2/useScrollTo.js"
import {getPresetsData} from "decentralized/presets/PresetsSearcher.js";
import PulseLoader from 'react-spinners/PulseLoader';
import PackContent from "components/packs/PackContent.js";
import {
    setPackSelected,
    setSamplesDragging,
    setCurrentSoundInList,
    setPackToEdit} from 'actions/index.js';
import Sample from "repos/Sample.js"
import {connect} from 'react-redux';

const PackDetails = ({
    sequencerEngine,
    pack,
    setSamplesDragging,
    setPackSelected,
    json,
    style,
    setPackToEdit,
    isEditing,
    userName,
    isSelected,
    currentPreset,
    currentSoundInList,
    setCurrentSoundInList,
    scrollRef,
}) => { 

    let ref = useRef(undefined);
    let [samples, setSamples] = useState(undefined);
    let [presets, setPresets] = useState(undefined);

    useScrollTo({ref, scrollRef, isCurrent: isSelected, topOffset: 120});

    const loadAsPads = useCallback(() => {
        sequencerEngine.currentSubSequence.loadPackAsPads(json.pad);
    }, [json]);

    const onClickEdit = useCallback(() => {
        setPackToEdit({
            ... json,
            ... pack,
            samples,
            presets
        });
    }, [json, presets, samples, pack]);

    useEffect(() => {
        if (!json) { return; }
        let _samples = [];
        let promises = [];
        for (let id of json.samples) {
            if (pack.matchingContent &&
                pack.matchingContent.length > 0 && 
                !pack.matchingContent.includes(id)) {
                continue;
            }
            let sample = new Sample(id);
            promises.push(sample.load());
            _samples.push(sample);
        }
        Promise.all(promises).then(
            x => setSamples(_samples));

        if (json.presets) {
            let _presets = json.presets;
            if (pack.matchingContent && pack.matchingContent.length > 0) {
                _presets = _presets.filter(
                    p => pack.matchingContent.includes(p));
            }
            getPresetsData(_presets)
                .then(setPresets);
        }
    }, [json, pack]);

    let className = "showing pack-option ";
    if (isEditing) {
        className += " editing";
    }
    if (isSelected) {
        className += " selected";
    }

    useEffect(() => {
        setPackSelected(pack);
    }, []);

    let currentPresetHash = currentPreset && currentPreset.contentHash;
    return (
        <div
          ref={ref}
          onDragStart={
              () =>
                  setSamplesDragging(samples)
          }
          onMouseDown={() => setPackSelected(pack)}
          draggable={true}
          style={style}
          className={className}>
          <div className="floppy-top">
            <div style={style} className="floppy-title">{pack.title}</div>
          </div>
          <div onClick={onClickEdit} className="pack-edit-btn">
            ...
          </div>
          <div className="floppy-sticker">
            {json.type === PAD ? <div
                                   onClick={loadAsPads}
                                   className="load-pack">Load as Pads</div> : ''}
            {!samples ? <PulseLoader
                          sizeUnit={"px"}
                          size={10}
                          color={'#123abc'}
                        /> :
             samples.map(
                 (x, i) => <PackContent
                             setIsCurrent={() => setCurrentSoundInList(i)}
                             isCurrent={currentSoundInList % samples.length === i }isEditing={false} sample={x}/>)}
            {presets ?
             presets.map(x => <PackContent
                                isCurrent={x.contentHash === currentPresetHash} isEditing={false} preset={x}/>) : ''}
          </div>
          {json && json.description !== "" ?
           <div className="floppy-sticker">
             {json.description}
           </div> : ""}
           <div className="pack-author">
             {userName}
           </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let sequencerEngine = state.sequencer.sequencerEngine; 
    let track =  sequencerEngine.getSelectedTrack();
    let isSelected = state.packs.packSelected === props.pack;
    return {
        isEditing: state.packs.packToEdit &&
            state.packs.packToEdit.packHash === props.pack.packHash,
        currentPreset: track && track.preset,
        isSelected, 
        currentSoundInList: isSelected ? state.selector.currentSoundInList : undefined
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPackToEdit: x => dispatch(setPackToEdit(x)),
      setPackSelected: x => dispatch(setPackSelected(x)),
      setSamplesDragging: x => dispatch(setSamplesDragging(x)),
      setCurrentSoundInList: x => dispatch(setCurrentSoundInList(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackDetails);
